import { render, staticRenderFns } from "./Segur.vue?vue&type=template&id=3f7e8f35&scoped=true"
import script from "./Segur.vue?vue&type=script&lang=js"
export * from "./Segur.vue?vue&type=script&lang=js"
import style0 from "./Segur.vue?vue&type=style&index=0&id=3f7e8f35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7e8f35",
  null
  
)

export default component.exports